module.exports = __webpack_public_path__ + "media/images/athletes/3406-4a3c52284065f244e1d18d4452dfaa55.png";